export default __webpack_public_path__ + "../images/production-1.jpg";